import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const TutorialCard = ({ tutorial, id }) => {
  const categoryIsDbt = typeof tutorial !== 'string';
  const title = categoryIsDbt ? tutorial.fields.title : tutorial;
  let slug;
  let icon;

  if (categoryIsDbt) {
    slug = tutorial.fields.slug;
    icon = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/dbt/dbt_tutorial_icon.svg`;
  } else {
    const name = tutorial.toLowerCase().split(' ').join('-');

    if (name === 'dbt') {
      slug = '/learn-dbt';
      icon = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/dbt/dbt_logo.jpg`;
    } else {
      slug = `/learn-sql/${name}`;
      icon = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/connections/${name}.svg`;
    }
  }

  return (
    <li key={id}>
      <Link href={slug} as={slug}>
        <a
          className={`block mb-2 font-inter bg-white shadow-features ${
            categoryIsDbt ? 'h-[170px] sm:h-[200px]' : 'h-48 md:h-[300px]'
          } rounded-xl text-black font-medium text-lg flex px-6 sm:px-0`}
        >
          <div
            className="w-[1px] ml-12 mr-8 hidden sm:block"
            style={{ background: 'rgba(0, 0, 0, 0.05)' }}
          ></div>
          <div className="flex flex-col items-baseline justify-between py-5 sm:py-8">
            <Image
              src={icon}
              alt={categoryIsDbt ? `dbt icon` : `${title.toLowerCase()} icon`}
              height={categoryIsDbt ? 50 : 75}
              width={categoryIsDbt ? 50 : 75}
            />
            {title}
          </div>
        </a>
      </Link>
    </li>
  );
};

const TutorialsGrid = ({ desc, tutorials }) => {
  return (
    <div className="w-full mt-2">
      <p className="text-2xl font-medium max-w-md text-center mx-auto mb-12 md:mb-28">
        {desc}
      </p>
      <ul className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-10 mt-8 sm:mt-16">
        {tutorials.map((tutorial, index) => (
          <TutorialCard tutorial={tutorial} key={index} id={index} />
        ))}
      </ul>
    </div>
  );
};

export default TutorialsGrid;
